import { Eye, EyeOff } from "lucide-react";
import { useState, type FormEvent } from "react";
import { useAuth } from "../../auth/AuthContext";
import { AutofillUsername } from "../../components/AutofillUsername";
import { usePageHeader } from "../../components/shell/PageHeaderContext";
import { Spinner } from "../../components/Spinner";
import { apiRequest } from "../../lib/api";
import { Feedback, useAction } from "../admin/shared";

/** The reviewer's own account: who they are and a password change (the first sign-in uses a temporary one). */
export function PartnerAccountPage() {
  usePageHeader("Mi cuenta", "Acceso al portal de aliados");
  const { user } = useAuth();
  const action = useAction();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [show, setShow] = useState(false);

  const submit = async (event: FormEvent) => {
    event.preventDefault();
    await action.run("password", async () => {
      const result = await apiRequest<{ data: { message: string } }>("/api/v1/profile/password", {
        method: "POST", body: JSON.stringify({ currentPassword: current, newPassword: next })
      });
      setCurrent(""); setNext("");
      return result.data.message;
    });
  };

  return (
    <div className="page-container admin-stack">
      <section className="card">
        <span className="rail-title">Revisor</span>
        <dl className="review-list loan-review">
          <div><dt>Nombre</dt><dd>{user?.fullName}</dd></div>
          <div><dt>Correo</dt><dd>{user?.email}</dd></div>
          <div><dt>Rol</dt><dd>{user?.role === "admin" ? "Administración Aventuria" : "Aliado financiero · Peso a Peso"}</dd></div>
        </dl>
      </section>
      <form className="card admin-form" onSubmit={submit}>
        <div className="section-heading"><div><span className="page-eyebrow">Seguridad</span><h2>Cambiar contraseña</h2></div></div>
        <p className="field-hint">Si entraste con la contraseña temporal que te entregó Aventuria, cámbiala ahora. 12 caracteres, mayúscula, minúscula, número y símbolo.</p>
        <AutofillUsername />
        <div className="field-grid">
          <div className="field-block">
            <label htmlFor="pw-current">Contraseña actual</label>
            <div className="password-field">
              <input id="pw-current" type={show ? "text" : "password"} className="standalone-input" value={current} onChange={(event) => setCurrent(event.target.value)} autoComplete="current-password" required />
            </div>
          </div>
          <div className="field-block">
            <label htmlFor="pw-next">Nueva contraseña</label>
            <div className="password-field">
              <input id="pw-next" type={show ? "text" : "password"} className="standalone-input" value={next} onChange={(event) => setNext(event.target.value)} autoComplete="new-password" minLength={12} required />
              <button type="button" className="field-icon" onClick={() => setShow((value) => !value)} aria-label={show ? "Ocultar contraseñas" : "Mostrar contraseñas"}>
                {show ? <EyeOff size={18} aria-hidden="true" /> : <Eye size={18} aria-hidden="true" />}
              </button>
            </div>
          </div>
        </div>
        <Feedback error={action.error} notice={action.notice} />
        <button className="primary-button solid" type="submit" disabled={action.busy !== null}>{action.busy === "password" ? <Spinner /> : null} Guardar contraseña</button>
      </form>
    </div>
  );
}
